<div
  id="barcodeScannerModalContainer"
  [class.modal-hidden]="!isVisible"
  [class.modal-visible]="isVisible">
  <div class="video-container">
    <div
      #cameraView
      class="dynamsoft-camera-view dce-video-container"
      aria-label="Live camera feed for barcode scanning">
    </div>
  </div>

  @if (isOpeningCamera) {
    <div class="camera-opening-loader" role="status" aria-live="polite" aria-busy="true">
      <app-shared-loading-g [animation]="scannerLoaderAnimation"></app-shared-loading-g>
      <p>Opening camera...</p>
    </div>
  }

  @if (cameraPreviewFailed && !isOpeningCamera) {
    <div class="camera-preview-error" role="alert">
      <p>The camera opened, but no video is showing.</p>
      <button type="button" class="camera-retry-button" (click)="onRetryCameraPreview()">
        <app-display-icon [colour]="iconColours.constant_white" [icon]="icons.sync">
        </app-display-icon>
        <span>Retry</span>
      </button>
    </div>
  }

  <div class="modal-actions-overlay">
    <div class="modal-close-button">
      <app-shared-button [colour]="'primary'" (buttonClicked)="onCloseModal()" [fill]="true">
        <div>
          <app-display-icon [colour]="iconColours.constant_white" [icon]="icons.close">
          </app-display-icon>
        </div>
      </app-shared-button>
    </div>

    @if (noBarcodeDetected) {
      <div class="no-barcode-message">
        <span>No barcode detected</span>
      </div>
    }

    @if (!isOpeningCamera && !cameraPreviewFailed) {
      <div class="modal-confirm-button">
        <button type="button" class="confirm-button" (click)="onConfirmScan()">
          <span>Confirm</span>
          <app-display-icon [colour]="iconColours.constant_white" [icon]="icons.checkBold">
          </app-display-icon>
        </button>
      </div>
    }
  </div>
</div>
